import { useHistory, useRouteMatch } from "react-router-dom";

import { Product } from "@transfr-inc/dashboard-components/constants";
import {
  useLiveClassroomListCount,
  useLiveStudentsInOrgCount,
} from "@transfr-inc/dashboard-sockets";

import { useCurrentUser, useMissionControlEnabled } from "@queries";
import { getLearnerTerm } from "@transfr-inc/dashboard-components/constants";

import {
  Shortcut,
  ShortcutAction,
  Shortcuts,
  ShortcutsHeader,
  ShortcutsList,
  ShortcutsTally,
  ShortcutsTitle,
} from "@components/shortcuts";
import { useTraineeInstructorCount } from "@hooks/queries";
import { ClassroomRoute, RootPath } from "@lib/routes.config";
import { createClassroomDetailLink } from "@lib/utils/navigation.utils";

const getClassroomsStats = (data, userCount) => {
  return [
    {
      description: "Classrooms",
      value: data?.length ?? "-",
    },
    {
      description: "Instructors",
      value: userCount?.totalInstructors
        ? // eslint-disable-next-line unicorn/no-array-reduce
          userCount.totalInstructors
        : "-",
    },
    {
      description: `${getLearnerTerm({ plural: true })}`,
      value: userCount?.totalTrainees
        ? // eslint-disable-next-line unicorn/no-array-reduce
          userCount.totalTrainees
        : "-",
    },
  ];
};

export function ClassroomsShortcuts({ classrooms, orgCode, products }) {
  const currentUser = useCurrentUser();
  const missionControlEnabled = useMissionControlEnabled();
  const socketUrl = process.env.SOCKET_BRIDGE_URL;
  const { token } = currentUser || {};
  let liveStudentsInOrg = {};
  let liveStudentsInClassrooms = {};

  if (missionControlEnabled) {
    liveStudentsInOrg = useLiveStudentsInOrgCount(socketUrl, token, orgCode);
    liveStudentsInClassrooms = useLiveClassroomListCount(
      socketUrl,
      token,
      orgCode
    );
  }
  const hasCEProduct = products?.includes(Product.CE);
  const { url } = useRouteMatch(RootPath);
  const history = useHistory();
  const classroomPath = `${url}${ClassroomRoute.path}`;

  const { data: userCount } = useTraineeInstructorCount(orgCode);
  const classroomsStats = getClassroomsStats(classrooms, userCount);

  const onManageClassroomsClick = () => {
    history.push(classroomPath);
  };

  return (
    <Shortcuts className="classrooms-shortcuts-container">
      <div className="orgs-shortcuts-header">
        <ShortcutsHeader icon="fa-light fa-screen-users" />
        <ShortcutsTitle text="Classrooms"></ShortcutsTitle>
      </div>
      <ShortcutsTally
        columns={[
          ...classroomsStats,
          ...(missionControlEnabled && hasCEProduct
            ? [
                {
                  description: `Live ${getLearnerTerm({ plural: true })}`,
                  value: liveStudentsInOrg ? liveStudentsInOrg : "0",
                },
              ]
            : []),
        ]}
      ></ShortcutsTally>
      <ShortcutsList>
        {classrooms.map((d, i) => (
          <Shortcut
            key={i}
            to={createClassroomDetailLink({
              classroomId: d.classroomId,
              search: {
                from: "Dashboard",
              },
            })}
            products={d.products}
            isProfessionalLearning={d.isProfessionalLearning}
            title={d.name}
            subtitle={`${d.totalTrainees} Users`}
            liveCount={
              missionControlEnabled && liveStudentsInClassrooms[d.classroomId]
                ? liveStudentsInClassrooms[d.classroomId]
                : 0
            }
          ></Shortcut>
        ))}
      </ShortcutsList>
      <div className="manage-action">
        <ShortcutAction onClick={onManageClassroomsClick}>
          Manage Classrooms
        </ShortcutAction>
      </div>
    </Shortcuts>
  );
}
